import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileComponent } from './profile/profile.component';
import { ProfileupdateComponent } from './profileupdate/profileupdate.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { CustomerAuthGaurd } from '../../auth/auth.guard';



const routes: Routes = [
  {path: 'dashboard', component: LandingPageComponent, canActivate: [CustomerAuthGaurd] },
  {path: 'profile', component: ProfileComponent, canActivate: [CustomerAuthGaurd]},
  {path: 'profile-update', component: ProfileupdateComponent, canActivate: [CustomerAuthGaurd] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProfileModuleRoutingModule { }
